export default (() => {

    const includes = (value, array) => {
        if (value === undefined || array === undefined) {            
            return wealthify.error.throwError('type.array.includes', 'value and array must be defined');
        }

        const valueIsArray = isArray(value);

        if (typeof value !== 'string' && !valueIsArray) {
            return wealthify.error.throwError('type.array.includes', 'value must be of type string or array');
        }

        if (!isArray(array)) {
            return wealthify.error.throwError('type.array.includes', 'array must be of type array');
        }
        
        return valueIsArray ? value.every((item) => array.includes(item)) : array.includes(value);
    };

    function isArray (value) {
        if (value === undefined) {            
            return wealthify.error.throwError('type.array.isArray', 'value must be defined');
        }
        
        return Array.isArray(value);
    }

    function isUniqueArray (value) {
        if (value === undefined) {            
            return wealthify.error.throwError('type.array.isUniqueArray', 'value must be defined');
        }

        if (!Array.isArray(value)) {
            return wealthify.error.throwError('type.array.isUniqueArray', 'array must be of type array');
        }

        const uniqueValues = [...new Set(value)];

        return value.length === uniqueValues.length;
    }

    function hasMinimumLength (value, minimumLength) {
        if (minimumLength === undefined) {
            return wealthify.error.throwError('type.array.hasMinimumLength', 'value must be defined');
        }

        if (!isArray(value)) {
            return wealthify.error.throwError('type.array.hasMinimumLength', 'array must be of type array');
        }

        return value.length >= minimumLength;
    }

    function toArray (value) {
        if (value === undefined) {            
            return wealthify.error.throwError('type.array.toArray', 'value must be defined');
        }

        if (isArray(value)) {
            return value;
        }

        if (typeof value !== 'string') {
            return wealthify.error.throwError('type.array.toArray', 'value must be of type string');
        }

        return wealthify.convert.toJson(value);
    }

    return {
        includes,
        isArray,
        isUniqueArray,
        toArray,
        hasMinimumLength
    };

})();